import { ComponentIds, HierarchyUtils, ViewerObjectComponent, } from "@inter-ikea-core/core";
import NonWorldlyItemComponent from "@inter-ikea-storagetwo/range/dist/components/NonWorldlyItemComponent";
import { getEntitySize } from "./getEntityData";
import { CANT_CREATE_VIEWER_OBJECT, NO_PARENT, NO_VIEWER_OBJECT, } from "@inter-ikea-storagetwo/range/dist/constants/errors";
// TODO: Look into what can be further generalized and moved into the range package instead.
/**
 * Creates a viewer object with registered input events.
 *
 * @param core - Core
 * @param entity - Entity to attach viewer object to
 * @param size - Vector object defining the size of the viewer object
 *
 * @returns The created viewer object
 */
export const createViewerObject = (core, entity, size) => {
    var _a;
    const { X, Y, Z } = size;
    const viewerObject = (_a = core.modules.viewer()) === null || _a === void 0 ? void 0 : _a.createBox(X, Y, Z, entity);
    if (!viewerObject)
        throw new Error(CANT_CREATE_VIEWER_OBJECT);
    viewerObject.registerInputEvents();
    viewerObject.setTransparency(0);
    return viewerObject;
};
/**
 * Creates a viewer object entity with an attached viewer object, that gets an entity parented to it.
 * Adds [NonWorldlyItemComponent] & [ViewerObjectComponent] to the viewer object entity.
 *
 * @param core - Core
 * @param entity - Entity to parent viewer object entity to
 * @param size - Vector object specifying the size of the viewer object
 *
 * @returns The created viewer object entity and viewer object
 */
export const createViewerObjectEntity = (core, entity, size) => {
    const viewerObjectEntity = core.services.entityManager.createEntity();
    const viewerObject = createViewerObject(core, viewerObjectEntity, size);
    HierarchyUtils.setParent(viewerObjectEntity, entity);
    viewerObjectEntity.addComponent(new ViewerObjectComponent(viewerObject));
    viewerObjectEntity.addComponent(new NonWorldlyItemComponent());
    return { viewerObjectEntity, viewerObject };
};
/**
 * Deletes the viewerObject when the viewer object entity is removed due to undo.
 *
 * @param viewerObjectEntity - Entity whose viewer object to retrieve and delete
 */
export const viewerObjectUndo = (viewerObjectEntity) => {
    var _a;
    const viewerObject = (_a = viewerObjectEntity.getComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID)) === null || _a === void 0 ? void 0 : _a.viewerObject;
    if (!viewerObject)
        throw new Error(NO_VIEWER_OBJECT);
    viewerObject.deleteObject();
};
/**
 * Creates and re-attaches a viewer object to an existing viewer object entity on redo.
 *
 * @param viewerObjectEntity - Entity to re-add viewer object component to
 * @param core - Core
 * @param sizeVector - Set a custom size instead of inheriting size of the parent entity.
 */
export function viewerObjectRedo(viewerObjectEntity, core, sizeVector) {
    let size;
    if (!sizeVector) {
        const parent = HierarchyUtils.parent(viewerObjectEntity);
        if (!parent)
            throw new Error(NO_PARENT);
        size = getEntitySize(parent);
    }
    else
        size = sizeVector;
    const viewerObject = createViewerObject(core, viewerObjectEntity, size);
    viewerObjectEntity.addComponent(new ViewerObjectComponent(viewerObject));
    return viewerObject;
}
